import { ICON_SIZE } from '@components/v2/constants';
import type { IconSize } from '@components/v2/types';
import { ElementType, type MouseEvent } from 'react';

interface IconProps {
  icon: ElementType;
  size?: IconSize;
  className?: string;
  ariaLabel?: string;
  onClick?: () => void;
  onMouseDown?: (event: MouseEvent) => void;
  role?: React.AriaRole;
}

const Icon = ({
  icon: IconComponent,
  size = 'md',
  className,
  ariaLabel,
  onClick,
  onMouseDown,
  role,
}: IconProps) => {
  return (
    <IconComponent
      size={ICON_SIZE[size]}
      className={className}
      aria-label={ariaLabel}
      onClick={onClick}
      onMouseDown={onMouseDown}
      role={role}
    />
  );
};

export default Icon;
